import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { CommonPostResponse, IPutAuthorizedServicesMain } from '../models/models'

export class PutAuthorizedServicesMainApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesMain/update',
      requesterInfo,
    })
  }

  public async putAuthorizedServicesMain(request: IPutAuthorizedServicesMain): Promise<CommonPostResponse> {
    return await this.putAsync<CommonPostResponse>(undefined, request)
  }
}
